import { memo } from "react";

import { useGetDarkMode } from "_common/hooks/global";

import Presentation from "./presentation";

const component = props => {

	const { handleEmojiSelect } = props;

	const darkMode = useGetDarkMode ();

	return (
		<Presentation
			darkMode          = { darkMode }
			handleEmojiSelect = { handleEmojiSelect }
		/>
	);
};

export default memo ( component );
